export const guidMatch = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

export const isGuid = (stringToCheck: string | null | undefined): boolean => {
  if (!stringToCheck || typeof stringToCheck !== 'string') {
    return false;
  }
  const match = stringToCheck.match(guidMatch);
  return match !== null && match[0] === stringToCheck;
};

export const getGuidRegexMatch = (stringToCheck: string | null | undefined): RegExpMatchArray | null =>
  stringToCheck?.match(guidMatch) ?? null;
